import type { Post } from "./loadPosts";

export const SITE_URL = "https://asdry.com";

export function articleCanonicalUrl(slug: string) {
  return `${SITE_URL}/blog/${slug}`;
}

export function absoluteContentUrl(value?: string) {
  return value ? new URL(value, SITE_URL).href : undefined;
}

export function getLinkBehavior(href?: string) {
  if (!href || href.startsWith("/") || href.startsWith("#")) {
    return { external: false } as const;
  }
  try {
    const external = new URL(href, SITE_URL).origin !== SITE_URL;
    return external
      ? ({ external: true, target: "_blank", rel: "noopener noreferrer" } as const)
      : ({ external: false } as const);
  } catch {
    return { external: false } as const;
  }
}

export function createBlogPostingJsonLd(post: Post) {
  const data: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.title,
    description: post.description,
    datePublished: post.publishedAt,
    author: {
      "@type": "Person",
      name: post.author,
    },
    publisher: {
      "@type": "Organization",
      name: "ASDRY LTD",
      url: SITE_URL,
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": post.canonicalUrl || articleCanonicalUrl(post.slug),
    },
  };
  if (post.updatedAt) data.dateModified = post.updatedAt;
  const image = absoluteContentUrl(post.image);
  if (image) data.image = image;
  return data;
}
